<template>

<div class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
    <div id="loading">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
    </div>
    <!-- <div style="display:none;" id="campaignResults"> -->
    <div  id="campaignResults" style="display: none;">

        <div class="row">
            <h1 class="page-header" id="page-title">Results for campaign.name</h1>
        </div>

        <div :style="[ this.user.role == 'Reader' && this.user.usb==true ? { display: 'none' } : null ]">
            <div class="row">
                <a href="/campaignsUsb" class="btn btn-default">
                    <i class="fa fa-arrow-circle-o-left fa-lg"></i> Back
                </a>
                <template v-if="this.user.role == 'Admin' && this.user.usb==true || this.user.role == 'User' && this.user.usb==true">
                    <div class="btn-group">
                        <button type="button" id="exportButton" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="true">
                            <i class="fa fa-file-excel-o"></i> Export CSV
                            <i class="fa fa-caret-down"></i>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="exportButton">
                            <li>
                                <a href="#" onclick="exportAsCSV('results')">Results</a>
                            </li>
                            <li>
                                <a href="#" onclick="exportAsCSV('events')">Raw Events</a>
                            </li>
                        </ul>
                    </div>
                    <button id="complete_button" type="button" class="btn btn-blue" data-toggle="tooltip" onclick="completeCampaignUsb()">
                        <i class="fa fa-flag-checkered"></i> Complete
                    </button>
                    <template v-if="this.user.role == 'Admin' &&  this.user.usb == true || this.user.role == 'User' &&  this.user.usb == true">
                        <button  id="update_button" type="button" class="btn btn-primary" data-toggle="tooltip" onclick="updateStatusCampaignUsb()">
                            <i class="fa fa-flag-checkered"></i> Upgrade
                        </button>
                    </template>
                    <button type="button" class="btn btn-danger" data-toggle="tooltip" onclick="deleteCampaignUsb()">
                        <i class="fa fa-trash-o fa-lg"></i> Delete
                    </button>
                </template>
                <button id="refresh_btn" type="button" class="btn btn-blue" data-toggle="tooltip" onclick="refreshUsb()">
                    <i class="fa fa-refresh fa-lg"></i> Refresh
                </button>
                <span id="refresh_message">
                    <i class="fa fa-spin fa-spinner"></i> Refreshing
                </span>
            </div>
            <br />
            <div class="row"> <!--  v-if="this.user.role != 'Reader'" -->
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div id="timeline_chart"></div>
                        </div>
                    </div>
                    
                    <div class="row" id="resultsMapContainer">
                        <div class="col-md-6">
                            <p style="text-align:center;">Targets Map</p>
                            <div id="resultsMap"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- blocco da nascondere a utente Reader -->

        <div class="row">
            <div class="container-general-stats">
                <div class="stats-title">Global stats</div>
               
                <div class="stat-box green">
                    <img src="../assets/images/stats/-usb-stick_86869.png" alt="Keys sent icon">
                    <div>
                        <div class="stat-percentage" id="generalStat_keysSent">-</div>
                        <div class="stat-description">Keys distributed</div>
                    </div>
                </div>
                <div class="stat-box green">
                    <img src="../assets/images/stats/-usb-stick_86869.png" alt="Keys sent icon">
                    <div>
                        <div class="stat-percentage" id="generalStat_keysReturned">-</div>
                        <div class="stat-description">Keys returned</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row" :style="[ this.user.role == 'Reader'  ? { display: 'none' } : null ]">
            <h2>Details</h2>
            <table id="resultsTable" class="table">
                <thead>
                    <tr>
                        <th>Result ID</th>
                        <th class="no-sort"></th>
                        <th>Campaign Name</th>
                        <th>Keys sent number</th>
                        <th>User</th>
                        <th>Customer</th>
                        <th>Status</th>
                        <th class="text-center">Reported</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
            </table>
        </div>
    </div>
    <div id="no-campaign-found" class="row"></div>
</div>

</template>
  
  <script>

  export default {
    name: 'CampaignResultsComponent',
    //props: {
    //  msg: String
    //}
    mounted() {

        let customScript = document.createElement('script')

        customScript.setAttribute('src', '/scripts/campaign_usb_results.js')

        customScript.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript)

        let customScript2 = document.createElement('script')

        customScript2.setAttribute('src', '/scripts/utils.js')

        customScript2.setAttribute('type', 'application/javascript')

        document.head.appendChild(customScript2)

    },
    methods: {
        getUserFromSession() {
            this.utente = window.sessionStorage.getItem('user');
        }
    },
    beforeMount() {
        this.user = window.sessionStorage.getItem("user");
        //console.log( " controllo 00 ----> " + this.user );
        this.user = JSON.parse(this.user);
        if (null != this.user) {
            this.username = this.user.username;
        }
        this.getUserFromSession()


    },
  }
  </script>
  
  <style>
  
  </style>
  